module.exports = __webpack_public_path__ + "img/clouds_2.d4686e2b.png";